module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    " + _vm._s(_vm.siteName) + " follows the COPE Code of Conduct and Best Practice Guidelines for Journal Editors and the Code of Conduct for Journal Publishers.\n    "), _c('a', {
    attrs: {
      "href": "http://publicationethics.org/resources/code-conduct",
      "target": "_blank"
    }
  }, [_vm._v(" http://publicationethics.org/resources/code-conduct")]), _vm._v(" "), _c('br'), _vm._v("\n    " + _vm._s(_vm.siteName) + " follows the COPE general guidelines as well.\n    "), _c('a', {
    attrs: {
      "href": "http://publicationethics.org/resources/guidelines",
      "target": "_blank"
    }
  }, [_vm._v("http://publicationethics.org/resources/guidelines")]), _vm._v(" "), _c('br'), _vm._v("\n    Also, editors, authors, reviewers should follow the best-practice guidelines on ethical behavior ICMJE’s Recommendations for the Conduct,\n    Reporting, Editing and Publication of Scholarly Work in Medical Journals.\n    "), _c('a', {
    attrs: {
      "href": " http://www.icmje.org/recommendations/",
      "target": "_blank"
    }
  }, [_vm._v(" http://www.icmje.org/recommendations/")]), _vm._v("  In addition, " + _vm._s(_vm.siteName) + "\n    follows the relevant guidelines from Elsevier and its journals.\n    "), _c('a', {
    attrs: {
      "href": "https://www.elsevier.com/editors/publishing-ethics/perk"
    }
  }, [_vm._v("https://www.elsevier.com/editors/publishing-ethics/perk")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30e6b256"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/EthicsAndMalpracticeComponent.vue
// module id = 1415
// module chunks = 1